import React from "react";
import styled from "styled-components";

const Layout = styled.div`
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 100;

  * {
      -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
      color-adjust: exact !important;                 /* Firefox 48 – 96 */
      print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
  }

  @media screen and (max-width: 769px) {
    ${({ $position }) => $position === "card" ? "display: block;" : "display: none;"}
  }

  @media screen and (min-width: 768px) {
    ${({ $position }) => $position === "card" ? "display: none;" : "display: block;"}
  }

  @media print {
    display: none;
  }
`;

const Button = styled.button`
  width: 50px;
  height: 50px;
  position: relative;
  padding: 0;
  border: 0;
  border: none;
  background: transparent;

  & span, & span::before, & span::after, &:hover span::after, &:active span::after {
    border: solid 2px ${({ $position }) => $position === "card" ? "#fff" : "#333"};
  }

  & span::after {
    border-width: 2px;
  }

  & span, & span::before, & span::after, &:hover span::after, &:active span::after {
    box-sizing: border-box;
    background-color: ${({ $position }) => $position === "card" ? "transparent" : "#fff"};
  }

  &:hover, &:active {
    cursor: pointer;
  }

  &:hover span::before, &:active span::before{
    height:0px;
    transition: height .2s;
  }

  &:hover span::after, &:active span::after {
    height:120%;
    transition: height .2s .15s, border-width 0s .16s;
  }
`;

const Icon = styled.span`
  position: relative;
  display: inline-block;  
  padding: 0;
  margin-top: 20%;

  width: 60%;
  height: 35%;
  background: #fff;
  border-radius: 20% 20% 0 0;

  &::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 12%;
    right: 12%;
    height: 110%;

    transition: height .2s .15s;
  }

  &::after {
    content: "";
    position: absolute;
    top: 55%;
    left: 12%;
    right: 12%;
    height: 0%;
    background: ${({ $position }) => $position === "card" ? "#333" : "#fff"};
    background-repeat: no-repeat;
    background-size: 70% 90%;
    background-position: center;
    background-image: linear-gradient(
      to top,
      #fff 0, #fff 14%,
      #333 14%, #333 28%,
      #fff 28%, #fff 42%,
      #333 42%, #333 56%,
      #fff 56%, #fff 70%,
      #333 70%, #333 84%,
      #fff 84%, #fff 100%
    );

    transition: height .2s, border-width 0s .2s, width 0s .2s;
  }
`;

const PrintButton = ({ onClick = () => {}, position }) => {
  const handleClick = e => {
    e.preventDefault();

    onClick();
    window.print();
  };

  // For some reason, supplying an onTouchEnd event
  // prevents Mobile Safari from requiring two clicks.
  return (
    <Layout $position={position}>
      <Button $position={position} onClick={handleClick} onTouchEnd={() => {}}>
        <Icon />
      </Button>
    </Layout>
  );
};

export default PrintButton;
